import React from 'react';
import { compose, setDisplayName } from 'recompose';
import classNames from 'classnames';
import Header from './Header';
import Checklist from '../../../Package/Checklist';
import styles from './Package.scss';

const Package = ({ service }) => (
  <div className={classNames(styles.root)}>
    <Header service={service} />
    <Checklist features={service.features} size="upgrade" />
  </div>
);

export default compose(setDisplayName('Package'))(Package);
